import React, { useState } from 'react';
import Form, {Assets} from '../../../Components/Form';
import DropZone, { useDropZone } from '../../../Components/Containers/DropZone';
import { classNames } from '../../../Services/helpers';
import ConversationReplyBox from './ConversationReplyBox';
import { replyDraftStorageKey } from './replyDraft';

const ReplyForm = ({conversation, addAdminMessage, className}) => {
    const [showAttachments, setShowAttachments] = useState(false);
    const canAddMessages = conversation.status === 'Active';

    return <DropZone onDrop={(files) => {
        if (files && files.length > 0) {
            setShowAttachments(true);
        }
    }}>
        <DropZoneHighlight>
            <div className={className}>
                <Form onSubmit={addAdminMessage} disabled={!canAddMessages} afterSubmit={() => {
                    setShowAttachments(false);
                    localStorage.removeItem(replyDraftStorageKey(conversation.id));
                }} resetOnSubmit>
                    <ConversationReplyBox
                        showAttachments={showAttachments}
                        setShowAttachments={setShowAttachments}
                        conversationId={conversation.id}
                        canAddMessages={canAddMessages}
                    />
                    <Assets name="assetIds"
                        label="Attachments"
                        accept="*/*"
                        tags={[{name: 'conversation', value: conversation.id}]}
                        hidden={!showAttachments}
                    />
                </Form>
            </div>
        </DropZoneHighlight>
    </DropZone>
}

export default ReplyForm;

const DropZoneHighlight = ({ children }) => {
    const dropZone = useDropZone();
    const isDraggingOver = dropZone?.isDraggingOver ?? false;

    return (
        <div className={classNames(
            'transition-all duration-200 rounded-lg',
            isDraggingOver && 'ring-2 ring-brand ring-offset-3 bg-brand/5'
        )}>
            {children}
        </div>
    );
};
